import React, { lazy } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const fadeIn = useFadeIn();
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    id: 1,
    emoji: '🧳',
    title: 'BONUS 1 — Brain Games Travel Kit',
    desc: 'Portable brain games for road trips, restaurants and waiting rooms. Zero screens needed.',
    image: 'https://cdn.magicpatterns.com/uploads/ot7R7YPBqPqVfhftpkHGZ8/bono_1_(9).webp',
    price: '$19'
  }, {
    id: 2,
    emoji: '🔓',
    title: 'BONUS 2 — Brain Escape Room',
    desc: 'Your child solves thrilling escape room adventures while training logic and critical thinking.',
    image: 'https://cdn.magicpatterns.com/uploads/r1kyo1kAt4pXbovkg2reKm/bono_2_(9).webp',
    price: '$19'
  }, {
    id: 3,
    emoji: '🕵️',
    title: 'BONUS 3 — Brain Detective Academy',
    desc: 'Your child becomes a little detective — cracking cases and strengthening attention and analysis.',
    image: 'https://cdn.magicpatterns.com/uploads/pYEYcGX7XrE3g6MwmzU5cT/bono_3_(8).webp',
    price: '$19'
  }, {
    id: 4,
    emoji: '👨‍👩‍👧‍👦',
    title: 'BONUS 4 — Family Brain Night',
    desc: 'Turn family time into exciting brain competitions everyone loves. Memory battles, logic showdowns, team missions and more.',
    image: 'https://cdn.magicpatterns.com/uploads/cAWCTHRp7jeUWd8hgv1rt8/bono_4_(9).webp',
    price: '$19'
  }, {
    id: 5,
    emoji: '🔬',
    title: 'BONUS 5 — Junior Inventor Lab',
    desc: 'Your child learns to design, build and invent — thinking like a young engineer. Includes an Official Inventor Certificate.',
    image: 'https://cdn.magicpatterns.com/uploads/8LsqjxGGZ6KExvrPdVtDbN/bono_5_(9).webp',
    price: '$19'
  }];
  return <section className="py-10 md:py-16 px-4 bg-gray-900 text-white border-y-8 border-yellow-400" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-29">
          <div className="text-center mb-8 md:mb-12" data-id="element-30">
            <h2 className="text-2xl md:text-5xl font-black text-yellow-400 mb-3 md:mb-4" data-id="element-31">
              🎁 5 FREE BONUSES
            </h2>
            <p className="text-base md:text-2xl font-bold text-white mb-3 md:mb-4" data-id="element-32">
              INCLUDED TODAY ONLY
            </p>
            <p className="text-xs md:text-base text-gray-400 font-medium max-w-2xl mx-auto" data-id="element-33">
              We are celebrating our 12,000th family milestone. Once this
              special offer ends, these bonuses return to their original
              standalone price.
            </p>
          </div>

          <div className="space-y-4 md:space-y-8 mb-8 md:mb-12" data-id="element-34">
            {bonuses.map(bonus => <div key={bonus.id} className="bg-white text-gray-900 rounded-2xl p-4 md:p-6 shadow-lg md:shadow-2xl relative border-2 md:border-4 border-yellow-400 overflow-hidden" style={{
            contentVisibility: 'auto',
            containIntrinsicSize: '0 400px'
          }} data-id="element-35">
                <div className="absolute top-3 md:top-4 right-[-40px] md:right-[-35px] bg-red-600 text-white font-black py-1 px-8 md:px-10 transform rotate-45 shadow-md text-[10px] md:text-base" data-id="element-36">
                  FREE
                </div>

                <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6" data-id="element-37">
                  {bonus.image ? <button onClick={scrollToPricing} className="w-full md:w-1/3 flex-shrink-0 cursor-pointer md:hover:scale-105 md:transition-transform" data-id="element-38">
                      <img src={bonus.image} alt={bonus.title} className="w-[160px] h-[160px] md:w-[250px] md:h-[250px] object-contain mx-auto drop-shadow-xl" loading="lazy" decoding="async" width={1080} height={1080} data-id="element-39" />
                    </button> : <div className="w-full md:w-1/3 flex-shrink-0 flex items-center justify-center" data-id="element-40">
                      <div className="w-[120px] h-[120px] md:w-[180px] md:h-[180px] bg-yellow-50 border-2 border-yellow-300 rounded-2xl flex items-center justify-center" data-id="element-41">
                        <span className="text-5xl md:text-7xl" data-id="element-42">
                          {bonus.emoji}
                        </span>
                      </div>
                    </div>}

                  <div className="text-center md:text-left flex-1" data-id="element-43">
                    <div className="inline-block bg-yellow-400 text-black font-black px-3 py-1 rounded-md mb-2 md:mb-3 text-xs md:text-sm uppercase tracking-wider" data-id="element-44">
                      {String(bonus.id).padStart(2, '0')}
                    </div>
                    <h3 className="text-lg md:text-2xl font-black text-gray-900 mb-2 md:mb-3 leading-tight" data-id="element-45">
                      {bonus.title}
                    </h3>
                    <p className="text-sm md:text-lg text-gray-600 mb-3 md:mb-4 font-medium" data-id="element-46">
                      {bonus.desc}
                    </p>
                    <p className="inline-block bg-gray-100 px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-bold text-gray-500 border border-gray-200" data-id="element-47">
                      <span className="line-through text-red-500" data-id="element-48">
                        {bonus.price}
                      </span>{' '}
                      <span className="text-green-600 ml-1 font-black" data-id="element-49">
                        FREE
                      </span>
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="text-center mb-8" data-id="element-50">
            <p className="text-lg md:text-2xl font-bold text-yellow-400" data-id="element-51">
              Total Bonus Value $95 →{' '}
              <span className="text-white" data-id="element-52">
                Included 100% FREE with your system today
              </span>
            </p>
          </div>

          <div className="max-w-md mx-auto" data-id="element-53">
            <CTAButton text="👉 GET THE SYSTEM WITH ALL 5 BONUSES" size="sm" data-id="element-54" />
          </div>
        </div>
      </div>
    </section>;
}